/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseAssetResponse } from '../../models/case-asset-response';

export interface UploadCaseAsset$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: {
'file'?: Blob;
}
}

export function uploadCaseAsset(http: HttpClient, rootUrl: string, params: UploadCaseAsset$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseAssetResponse>> {
  const rb = new RequestBuilder(rootUrl, uploadCaseAsset.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseAssetResponse>;
    })
  );
}

uploadCaseAsset.PATH = '/api/v1/cases/{id}/assets';
